import type { RPhoneNumber } from 'v2/types/api/settings'
import type { AppType } from './configure-number.config'

/**
 * Single source of truth for classifying a number's routing configuration.
 *
 * Precedence (most authoritative first):
 *   1. `app_type` — emitted authoritatively by contacto-core. Trust it verbatim.
 *   2. `trunk_id` — SIP trunk.
 *   3. `phlo_ids` — AI agent (an active call/message/whatsapp flow mapping).
 *   4. `app_id`   — XML application.
 *   5. otherwise  — null (unconfigured).
 *
 * Used by BOTH the phone-number table (Configuration column) and the
 * configure-number form (defaultValues) so the two can never disagree on type
 * (the cause of the "list shows Application, form shows SIP Trunk" mismatch).
 */
export const classifyNumberConfig = (
  pn?: Pick<RPhoneNumber, 'app_type' | 'trunk_id' | 'app_id' | 'phlo_ids'> | null,
): AppType | null => {
  if (!pn) return null
  if (pn.app_type) return pn.app_type
  if (pn.trunk_id) return 'trunk'
  if (pn.phlo_ids?.length) return 'agent'
  if (pn.app_id) return 'xml'
  return null
}
